import { SelectionModel } from '@angular/cdk/collections';
import { Component, EventEmitter, Input, OnInit, Output, SimpleChanges } from '@angular/core';
import { ProfileDTO } from '@app/user-profiles/model/user-profiles-model';
import { UserProfilesStore } from '@app/user-profiles/user-profiles-service/user-profiles-service.store';

@Component({
  selector: 'scf-user-profiles-single',
  templateUrl: './user-profiles-single.component.html',
  styleUrls: ['./user-profiles-single.component.scss'],
})
export class UserProfilesSingleComponent implements OnInit {
  @Output() selectedProfile = new EventEmitter<ProfileDTO>();
  @Input() isUpdate: boolean;

  selection = new SelectionModel<ProfileDTO>(false, []);
  profileList: ProfileDTO[];
  displayedColumns: string[] = ['profile', 'selection'];

  constructor(private userProfilesStore: UserProfilesStore) {}

  ngOnInit(): void {
    this.loadProfiles();

    this.userProfilesStore.reloadProfiles$.subscribe((data: boolean) => {
      if (data !== false) {
        this.loadProfiles();
        this.userProfilesStore.setReloadProfiles(false);
      }
    });
  }

  loadProfiles() {
    this.userProfilesStore.getListProfiles().then(
      (data) => (this.profileList = data),
      (error) => console.error(error)
    );
  }

  sendProfile() {
    if (this.selection.hasValue()) {
      this.selectedProfile.emit(this.selection.selected[0]);
    }
  }
}
